export const TypicalResponseTimeOptions = [
  { value: 0, label: 'Do not display estimate' },
  { value: 1, label: 'As soon as possible' },
  { value: 2, label: 'Within a few minutes' },
  { value: 3, label: 'Within a few hours' },
  { value: 4, label: 'Within a day' },
];
